var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pilot-dialog",
      class: {
        "pilot-dialog--minify": _vm.minify,
        "pilot-dialog--right": _vm.position === "right",
        "pilot-dialog--left": _vm.position === "left",
      },
    },
    [
      !_vm.noHeader
        ? _c("div", { staticClass: "pilot-dialog__header" }, [
            _c(
              "div",
              { staticClass: "pilot-dialog-header-left" },
              [_vm._t("header-left")],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "pilot-dialog-title" }, [
              _c(
                "span",
                { staticClass: "pilot-dialog-title__icon" },
                [_vm._t("header-title-icon-left")],
                2
              ),
              _vm._v(" "),
              _c("span", { staticClass: "pilot-dialog-title__text" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "pilot-dialog-title__icon" },
                [_vm._t("header-title-icon-right")],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pilot-dialog-header-right" },
              [_vm._t("header-right")],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "pilot-dialog__body",
          class: {
            "pilot-dialog__body--scrollable": _vm.scrollable,
          },
        },
        [_vm._t("body")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }